var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEC\x9D\xB8 \xEC\x8B\xAC\xEB\xB3\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.99838 15.9999C1.70699 15.9999 1.41505 15.8935 1.18664 15.6787C0.715045 15.2348 0.696422 14.4957 1.14447 14.0285C3.96803 11.0858 3.96803 6.47618 1.14447 3.5335C0.696422 3.06629 0.715045 2.32777 1.18664 1.88336C1.65824 1.43894 2.40371 1.45794 2.8523 1.92514C6.54183 5.76968 6.54183 11.7923 2.8523 15.6363C2.62061 15.8778 2.31004 15.9993 1.99838 15.9993V15.9999Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6601 15.9999C17.3485 15.9999 17.0379 15.8784 16.8062 15.6369C13.1167 11.7924 13.1167 5.76971 16.8062 1.92517C17.2543 1.45797 18.0003 1.43952 18.4719 1.88339C18.9435 2.32726 18.9621 3.06633 18.514 3.53353C15.6899 6.47622 15.6899 11.0859 18.514 14.0285C18.9621 14.4958 18.9435 15.2343 18.4719 15.6787C18.244 15.8936 17.9521 15.9999 17.6601 15.9999Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.87255 8.84331C7.1903 8.84331 5.06346 8.01797 3.74013 7.31635C3.12996 6.99294 2.89991 6.24031 3.22691 5.63582C3.55336 5.03133 4.31306 4.80343 4.92324 5.12738C6.01651 5.70745 7.78843 6.39116 10.0254 6.35969C12.0881 6.32985 13.728 5.6966 14.7413 5.17025C15.3543 4.85172 16.1118 5.08614 16.4333 5.69334C16.7548 6.30055 16.5182 7.051 15.9053 7.36953C14.1065 8.30394 12.0854 8.81347 10.0621 8.84277C9.99908 8.84385 9.93609 8.8444 9.87365 8.8444L9.87255 8.84331Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.22052 2.77284C7.79105 2.77284 8.25355 2.15212 8.25355 1.38642C8.25355 0.620722 7.79105 0 7.22052 0C6.65 0 6.1875 0.620722 6.1875 1.38642C6.1875 2.15212 6.65 2.77284 7.22052 2.77284Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.4471 2.77284C13.0176 2.77284 13.4801 2.15212 13.4801 1.38642C13.4801 0.620722 13.0176 0 12.4471 0C11.8766 0 11.4141 0.620722 11.4141 1.38642C11.4141 2.15212 11.8766 2.77284 12.4471 2.77284Z",
    fill: "#25569D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f7ae0add0cea858a43c31c5103770a03.svg";
export { ForwardRef as ReactComponent };